import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { StrategiesService } from './strategies.service';
import { IStrategy } from '../../models/IStrategy';
import { InstitutionService  } from '../../auth/services/institution.service';
import {DefaultDashboardRequest} from '../../shared/models/api/StrtDashboardRequest';


@Injectable()
export class StrategiesListResolve implements Resolve<IStrategy[]> {
  constructor(private strategiesService: StrategiesService, private institutionService: InstitutionService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IStrategy[]> {
    const institutionId = Number.parseInt(route.paramMap.get('institutionId'), 10);
    this.institutionService.institutionId = institutionId;
    return this.strategiesService.list(institutionId, DefaultDashboardRequest);
  }
}
